module.exports = __webpack_public_path__ + "static/brascol-expobaby-lp-c2bdbacd79ad6d1dac535d040890f5c5.jpg";